import React, { useState, useEffect } from 'react';
import { InputField, CustomInputField } from './inputFields';
import { useTranslation } from "react-i18next";

const CityFields = (props) => {
    const { t } = useTranslation();
    const [checked, setChecked] = useState(false);
    const [count, setCount] = useState(0);
    const {initialValues} = props;
    
    useEffect(() => {
        if (count === 0) {
            if (initialValues && !initialValues.delivery) {
                setChecked(true);
                setCount(count + 1);
            } 
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialValues]);

    const handleCheckedChange = (event) => {
        const checked = event.target.checked;
        setChecked(checked);
    };

    return (
        <div className={props.className}>
            <InputField
                name="deliveryLimit" 
                title={t("delivery.minDeliveryAmount")}
                placeholder={t("delivery.placeholders.minDeliveryAmount")}
                validMsg={t("delivery.validation.minDeliveryAmount")} />

            <InputField
                name="deliveryFreeLimit" 
                title={t("delivery.freeDeliveryFrom")}
                placeholder={t("delivery.placeholders.freeDeliveryFrom")}
                validMsg={t("delivery.validation.freeDeliveryFrom")} />

            <CustomInputField
                name="delivery"
                checked={checked}
                handleCheckedChange={handleCheckedChange}
                title={t("delivery.deliveryCost")}
                popover={false}
                checkBox={true}
                placeholder={t("delivery.placeholders.deliveryCost")}
                validMsg={t("delivery.validation.deliveryCost")}
                checkboxTitle={t("delivery.freeDelivery")} />
        </div>
    )
}

export default CityFields;
